import React, { FC } from 'react';

import { useHistory } from 'react-router-dom';

import { Loader } from '../../components/Loader';
import { LearnerInfo } from '../../types';
import { useAuth } from '../../utils/hooks';

interface LoginPageProps {
  userInfo: LearnerInfo;
  userLoading: boolean;
}

const LoginPage: FC<LoginPageProps> = ({ userInfo, userLoading }) => {
  const history = useHistory();
  const { loginWithRedirect } = useAuth();

  if (!userLoading && userInfo) {
    history.replace('/home');
  } else {
    const hasPrevUrl = history.location?.state?.prevPath && history.location.state.prevPath !== '/';
    loginWithRedirect({
      redirectUri: hasPrevUrl
        ? `${history.location.state.prevPath}${history.location.state.prevSearch || ''}`
        : '/home',
      isDirectUrl: !hasPrevUrl,
    });
  }

  return <Loader />;
};

export default LoginPage;
